<template>
	<div class="allbg">
		<!-- 头 -->
		<tyheader pageind="6"/>
		<section class="n_banner" :style=" 'background:url('+bannerurl+') center no-repeat;'"></section>
		<section class="n_title n_title01">
			<div class="w1400 pagetit">
				<div class="left">
					<div class="n_nav">
						<a v-for="(item, index) in newsmenu" :key="index" :class="{on:newstabind == index}" @click="otherrout(item.code,index)" style="cursor: pointer;"><strong>{{item.title}}</strong></a>
						<!-- <a class="on" href="#"><strong>双沟新闻</strong></a>
						<a href="#"><strong>媒体报道</strong></a>
						<a href="#"><strong>双沟酒讯</strong></a>
						<a href="#"><strong>行业动态</strong></a>
						<a href="#"><strong>视频中心</strong></a>
						<a href="#"><strong>集团公告</strong></a>
						<a href="#"><strong>招标信息</strong></a> -->
					</div>
				</div>
				<div class="right ">
					<div class="position"><a href="#">首页</a> <i>-</i> <a>社会责任</a> <i>-</i> <em>{{newsmenutit}}</em> </div>
				</div>
			</div>
		</section>
		<section class="n_container">
			<div class="w1400">
				<div class="newsdetmod">
					<div class="jobs-wrapper news-detail-wrapper">
						<div class="detail-head">
							<div class="title">
								<h2>{{newsinfo.title}}</h2>
								<p><span>发布日期：{{newsinfo.time}}</span><span v-if="newsinfo.source">来源：{{newsinfo.source}}</span><span>浏览量：{{newsinfo.clicks}}次</span></p>
							</div>
						</div>
						<div  v-html="newsinfo.content"></div>
						<div class="backpage" @click="backpage()">返回</div>
					</div>
					<div class="wrap-nlist">
						<div class="title-nlist">
							<h2>推荐新闻</h2>
						</div>
						<ul>
							<li v-for="(item,index) in newslist" v-if="index<6" :key="index">
								<h3><a :href="'/newsdetail?code='+item.code+'&ind=0'">{{item.title}}</a></h3>
								<p><a :href="'/newsdetail?code='+item.code+'&ind=0'">{{item.intro}}</a></p>
								<span>2020-12-30</span>
							</li>
							<!-- <li>
								<h3><a href="/news/200.html">太湖锅炉出口埃及98吨燃油锅炉安装报道</a></h3>
								<p><a href="/news/200.html">江苏太湖锅炉股份有限公司于2018年10月份出口埃及客户的一台SZS98-1.4/255-Y燃油锅炉（按照美国机械工程师协会ASME标准设计、制作）正在安装中。 该产品由...</a></p>
								<span>2019-12-18</span>
							</li>
							<li>
								<h3><a href="/news/161.html">太湖锅炉行业获奖报道</a></h3>
								<p><a href="/news/161.html">备受瞩目的中国电器工业协会工业锅炉分会七届二次会员大会于2019年11月24日在上海青松城大酒店隆重召开，工业锅炉行业巨头集聚一堂，共襄盛会。江苏...</a></p>
								<span>2019-11-26</span>
							</li> -->
						
					  </ul>
					</div>
				</div>
				
				<div class="news-other">
					<p>上一篇：<a v-if="newsinfo.np" :href="'/newsdetail?code='+newsinfo.np.prev.code+'&ind='+newstabind">{{newsinfo.np.prev.title}}</a><span v-else>已经没有了</span></p>
					<p>下一篇：<a v-if="newsinfo.np" :href="'/newsdetail?code='+newsinfo.np.next.code+'&ind='+newstabind">{{newsinfo.np.next.title}}</a><span v-else>已经没有了</span></p>
				</div>
			</div>
		</section>
		<tyfooter></tyfooter>
	</div>
</template>

<script>
	import tyheader from './header.vue'
	import tyfooter from './footer.vue'
	export default {
	  name: 'product',
		components: {
			tyheader,
			tyfooter
		},
		metaInfo () {
			return {
				title: this.seot,
				meta: [   // set meta
					{                
						name: 'keyWords',
						content: this.seok
					},
					{
						name: 'description',
						content: this.seod
					}
				]
			}
		},
		data(){
			return{
				seot:this.COMMON.seotit,
				seod:this.COMMON.seodec,
				seok:this.COMMON.seokey,
				isshow:this.COMMON.isshow(),
				imgurl:this.COMMON.imgurl,
				newscode:'',
				newsinfo:'',
				newstabind:[],
				newslist:[],
				newsmenu:'',
				newsmenutit:'',
				bannerurl:''
			}
		},
		computed:{
			
		},
		mounted() {
			let that = this
			console.log(this.$route.query.code)
			this.newscode = this.$route.query.code
			that.newstabind = this.$route.query.ind
			this.getmenulist()
			this.getnewsdetail()
			this.getnewslist()
			that.$axios.post('/w/menu').then(function (response) {
				that.bannerurl = that.imgurl + response.data[5].banner
			}).catch(function (error) {
					console.log(error);
			});
			// this.$axios.post('/w/art/click?code='+this.newscode).then(function (response) {
			// 	console.log(response.data)
			// })
			// .catch(function (error) {
			// 	console.log(error);
			// });
			that.$axios.post('/w/pageseo?address='+'/shzrdetail').then(function (response) {
				if(JSON.stringify(response.data) != "{}"){
					// that.seot = response.data.seoTitle
					that.seok = response.data.seoKey
					that.seod = response.data.seoDes
				}
			}).catch(function (error) {
					console.log(error);
			});
		},
		methods:{
			backpage(){
				this.$router.go(-1)
			},
			getnewsdetail(){
				let that = this
				this.$axios.post('/w/art?menuCode=&&amount=&&page=&&code='+that.newscode).then(function (response) {
					console.log(response.data)
					document.title = response.data.list[0].title
					response.data.list[0].time = response.data.list[0].time.split(' ')[0]
					// response.data.list[0].np.next = response.data.list[0].np.next ? response.data.list[0].np.next : ''
					// response.data.list[0].np.prev = response.data.list[0].np.prev ? response.data.list[0].np.prev : ''
					that.newsinfo = response.data.list[0]
					that.newsmenutit = response.data.list[0].menu
					that.seot = response.data.list[0].title + ' - 江苏双沟酒业股份有限公司'
				})
				.catch(function (error) {
					console.log(error);
				});
			},
			getnewslist(num,ind){
				let that = this
				this.$axios.post('/w/art?code=&&amount=&&page=&&menuCode='+'1631172414012').then(function (response) {
					response.data.list.forEach((val,ind) => {
						val.time = val.time.split(' ')[0]
					})
					that.newslist = response.data.list
				})
				.catch(function (error) {
					console.log(error);
				});
			},
			getmenulist(){
				let that = this
				this.$axios.post('/w/menu?code=1631174219756').then(function (response) {
					that.newsmenu = response.data
					
				})
				.catch(function (error) {
					console.log(error);
				});
			},
			otherrout(num,ind){
				this.$router.push({path:'/shzr',query: {type:num,ind:ind}})
			}
		},
		watch:{
			
		}
	}
</script>

<style scoped="scoped">
	article, aside, footer, header, nav, section {display: block;}
	img {
	    border-style: none;
	    max-width: 100%;
	    vertical-align: top;
	    width: auto!important;
	    height: auto!important;
	}
	.n_banner {height: 70vh;background-size: cover !important;}
	.n_title {height: 74px;border-bottom: #e7e7ea 1px solid;padding: 0;position: relative;background: #fff;}
	.pagetit{display: flex;justify-content: space-between;}
	.n_nav {position: relative;}
	.n_nav a {display: inline-block;height: 74px;font-size: 18px;float: left;line-height: 75px;color: #333333;text-align: center;box-sizing: border-box;position: relative;-moz-border-radius: 3px;-webkit-border-radius: 3px;border-radius: 3px;margin-right: 3.125rem;}
	.n_nav a:before {content: "";width: 0;height: 3px;position: absolute;bottom: 0;left: 0;background: #119e7f;transition: 0.6s ease-in-out;}
	.n_nav .on:before, .n_nav a:hover:before {width: 100%;}
	.position {line-height: 74px;color: #7b7b7d;padding-left: 22px;font-size: 14px;background: url(../assets/images/home_icon.png) left 30px no-repeat;}
	.position i {
		margin: 0px 5px;
		font-style: normal;
	}
	.position span, .position a, .position i {
		font-size: 14px;
		color: #7b7b7d;
		-moz-transition: all 0.36s ease-in-out;
		-webkit-transition: all 0.36s ease-in-out;
		-o-transition: all 0.36s ease-in-out;
		-ms-transition: all 0.36s ease-in-out;
		transition: all 0.36s ease-in-out;
	}
	.position em {
		font-size: 14px;
		color: #acacac;
		font-style: normal;
	}
	.n_container {
		background: url(../assets/images/n_container_bg.jpg) center bottom no-repeat #fff;
		background-size: 100% auto;
		width: 100%;
		padding-bottom: 30px;
		padding-top: 30px;
	}
	.news-detail-wrapper {
	    padding-left: 0!important;
			padding-right: 40px;
	}
	.detail-head {
	    position: relative;
	    margin-bottom: 15px;
	}
	.detail-head .title {
	    margin-bottom: 10px;
	}
	.detail-head .title h2 {
	    font-size: 26px;
	    color: #33383b;
	    line-height: 30px;
	    margin-bottom: 5px;
	    font-weight: normal;
	    text-align: center;
	}	
	.detail-head .title p {
	    font-size: 14px;
	    color: #71797e;
	    line-height: 20px;
	    margin-top: 10px;
	    text-align: center;
	}
	.detail-head .title p span {
	    margin-right: 20px;
	}
	
	.news-other {
	    padding-top: 20px;
	    border-top: 1px solid #e5e5e5;
	    margin-top: 50px;
			text-align: left;
	}
	.news-other p {
	    font-size: 14px;
	    color: #71797e;
	    line-height: 20px;
	    padding-top: 10px;
	}
	.news-other p a {
	    color: #71797e;
	}
	
	.newsdetmod{
		display:flex;
		justify-content: space-between;
		
	}
	
	.wrap-nlist {overflow: hidden;width: calc(30% - 40px);padding-left: 40px; border-left: 1px solid #eee;text-align: left;padding-top: 35px;}
	.wrap-nlist .title-nlist h2 {
	    font-size: 22px;
	    line-height: 1.5;
	    display: inline-block;
	    margin: 0;font-weight: normal;
	    border-bottom: 3px solid #119e7f;
	}
	.wrap-nlist ul li {
	    padding: 20px 0;
	    border-bottom: 1px solid #dcdcdc;
	}
	.wrap-nlist ul li h3 {
	    font-size: 18px;
	    line-height: 32px;
	    display: -webkit-box;
	    overflow: hidden;
	    height: 32px;
	    margin: 0;
	    -webkit-transition: all .4s;
	    transition: all .4s;
	    color: #333;
	    -webkit-box-orient: vertical;
	    -webkit-line-clamp: 1;
	}
	.wrap-nlist ul li a {
	    display: block;
	}
	.wrap-nlist ul li p {
	    font-size: 14px;
	    line-height: 1.73333333;
	    display: -webkit-box;
	    overflow: hidden;
	    height: 50px;
	    margin: 0;
	    color: #999;
	    -webkit-box-orient: vertical;
	    -webkit-line-clamp: 2;
	    margin-top: 10px;
	}
	.wrap-nlist ul li span {
	    font-size: 15px;
	    display: block;
	    margin-top: 8px;
	    color: #808080;
	}
	@media screen and (max-width: 767px) {
		.n_title{height: 50px;}
		.n_nav a{height: 50px;line-height: 50px;}
		.position{line-height: 50px;background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAMCAYAAAC5tzfZAAAAuElEQVQokZXRoU4DQRQF0LOT0RtCkKTB9Qdo+QY0hg+ApAKaFQj6G8XVUlldW40kCMjK6josEMxsMkyWQK95L3PnJJNM1TSNnsxwh0XafyT2gDlu036PI1znF0IBVhnocoV1H6rxhIu+t+I89YcdOsMLxr+ALmM8YxSwxOAP0OUYjwGX+PgngknAK772QG3EAaqieECLIW6Kro4JlGia7SWqQgLlJ58UM0+M2GGD06z4zOZ7dv6G7TfQZhwU9L0NbQAAAABJRU5ErkJggg==) left 19px no-repeat;}
	  .left{width: 7rem;
	  height: 50px;
	  overflow: hidden;}
		.left{background: url(../assets/images/downarr.png) right 15px no-repeat ;background-size: 20px;}
		.left:hover{height:auto;background: url(../assets/images/downarr.png) right 15px no-repeat #ffffff;background-size: 20px;box-shadow: 0px 0px 10px rgb(0,0,0,0.5);}
	}
</style>
